import React from 'react';

const TermsAndConditions = () => {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.6' }}>
      <h1>Terms and Conditions</h1>
      <p><strong>Effective Date:</strong> April 14, 2026</p>
      <p><strong>Last Updated:</strong> April 14, 2026</p>

      <h2>1. Introduction</h2>
      <p>
        Welcome to Sai Ananta ("we," "our," or "us"). These Terms and Conditions ("Terms") govern your access to and use of our website located at https://sai-ananta-website.vercel.app/ and any related services provided by us.
      </p>
      <p>
        By accessing or using our website, you agree to be bound by these Terms. If you do not agree with any part of these Terms, please do not use our website.
      </p>

      <h2>2. Definitions</h2>
      <ul>
        <li><strong>"Website"</strong> refers to the Sai Ananta website and all its pages.</li>
        <li><strong>"User," "You,"</strong> or <strong>"Your"</strong> refers to any individual or entity accessing our website.</li>
        <li><strong>"We," "Us,"</strong> or <strong>"Our"</strong> refers to Sai Ananta, its developers (Shree Venkateshwara Group & Shinde Group), and associated entities.</li>
        <li><strong>"Property"</strong> refers to the residential apartments and related real estate offered by Sai Ananta.</li>
      </ul>

      <h2>3. Use of the Website</h2>
      
      <h3>3.1 Eligibility</h3>
      <p>
        You must be at least 18 years of age to use this website. By using the website, you represent and warrant that you are of legal age to form a binding contract.
      </p>

      <h3>3.2 Permitted Use</h3>
      <p>You may use our website for lawful purposes only, including:</p>
      <ul>
        <li>Viewing property information</li>
        <li>Submitting enquiries and booking site visits</li>
        <li>Accessing general information about Sai Ananta</li>
      </ul>

      <h3>3.3 Prohibited Activities</h3>
      <p>You agree NOT to:</p>
      <ul>
        <li>Use the website for any unlawful or fraudulent purpose</li>
        <li>Attempt to gain unauthorized access to our systems or networks</li>
        <li>Transmit viruses, malware, or any harmful code</li>
        <li>Collect or harvest personal information of other users</li>
        <li>Reproduce, duplicate, or copy any content without written permission</li>
        <li>Use automated systems (bots, scrapers) to access the website</li>
        <li>Misrepresent your identity or affiliation</li>
      </ul>

      <h2>4. Property Information and Pricing</h2>
      
      <h3>4.1 Accuracy of Information</h3>
      <p>
        We strive to provide accurate and up-to-date information about our properties, including pricing, specifications, amenities, and availability. However, all information is subject to change without notice.
      </p>

      <h3>4.2 No Guarantee of Availability</h3>
      <p>
        Property availability, pricing, and specifications displayed on the website are for informational purposes only and do not constitute an offer to sell. Final pricing and availability will be confirmed during the booking process.
      </p>

      <h3>4.3 RERA Compliance</h3>
      <p>
        Sai Ananta is registered under MahaRERA with Registration Number: <strong>PR1260002502966</strong>. All property transactions will comply with the Real Estate (Regulation and Development) Act, 2016 (RERA).
      </p>

      <h2>5. Enquiries and Site Visits</h2>
      
      <h3>5.1 Submission of Information</h3>
      <p>
        When you submit an enquiry or book a site visit, you authorize us to contact you via phone, email, SMS, or WhatsApp to provide information and schedule visits.
      </p>

      <h3>5.2 Accuracy of Submitted Information</h3>
      <p>
        You agree to provide accurate, complete, and current information when submitting forms. We are not responsible for any issues arising from incorrect or incomplete information.
      </p>

      <h3>5.3 Site Visit Terms</h3>
      <p>
        Site visits are subject to availability and must be scheduled in advance. We reserve the right to cancel or reschedule visits due to unforeseen circumstances.
      </p>

      <h2>6. Intellectual Property Rights</h2>
      
      <h3>6.1 Ownership</h3>
      <p>
        All content on this website, including text, images, graphics, logos, videos, and designs, is the property of Sai Ananta or its licensors and is protected by copyright, trademark, and other intellectual property laws.
      </p>

      <h3>6.2 Limited License</h3>
      <p>
        You are granted a limited, non-exclusive, non-transferable license to access and use the website for personal, non-commercial purposes. You may not modify, distribute, or reproduce any content without prior written consent.
      </p>

      <h2>7. Third-Party Links and Services</h2>
      <p>
        Our website may contain links to third-party websites or services. We are not responsible for the content, privacy practices, or terms of use of these external sites. Your use of third-party websites is at your own risk.
      </p>

      <h2>8. Disclaimer of Warranties</h2>
      <p>
        Our website is provided on an "AS IS" and "AS AVAILABLE" basis without warranties of any kind, either express or implied, including but not limited to:
      </p>
      <ul>
        <li>Accuracy, completeness, or reliability of information</li>
        <li>Uninterrupted or error-free access to the website</li>
        <li>Fitness for a particular purpose</li>
        <li>Non-infringement of third-party rights</li>
      </ul>
      <p>
        We do not guarantee that the website will be free from viruses, bugs, or other harmful components.
      </p>

      <h2>9. Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by law, Sai Ananta, its developers, affiliates, employees, and agents shall not be liable for any direct, indirect, incidental, consequential, or punitive damages arising from:
      </p>
      <ul>
        <li>Your use or inability to use the website</li>
        <li>Errors, inaccuracies, or omissions in content</li>
        <li>Unauthorized access to your information</li>
        <li>Loss of data or business interruption</li>
        <li>Third-party content or services</li>
      </ul>
      <p>
        Our total liability, if any, shall not exceed the amount paid by you (if applicable) for accessing the website.
      </p>

      <h2>10. Indemnification</h2>
      <p>
        You agree to indemnify, defend, and hold harmless Sai Ananta, its developers, affiliates, and representatives from any claims, damages, losses, liabilities, and expenses (including legal fees) arising from:
      </p>
      <ul>
        <li>Your violation of these Terms</li>
        <li>Your misuse of the website</li>
        <li>Your infringement of any third-party rights</li>
      </ul>

      <h2>11. Modifications to Terms</h2>
      <p>
        We reserve the right to modify, update, or revise these Terms at any time without prior notice. The updated Terms will be posted on this page with a revised "Last Updated" date. Your continued use of the website after changes constitutes acceptance of the new Terms.
      </p>

      <h2>12. Termination</h2>
      <p>
        We reserve the right to suspend or terminate your access to the website at any time, with or without cause or notice, if we believe you have violated these Terms or engaged in prohibited activities.
      </p>

      <h2>13. Governing Law and Jurisdiction</h2>
      <p>
        These Terms shall be governed by and construed in accordance with the laws of India. Any disputes arising from or related to these Terms or your use of the website shall be subject to the exclusive jurisdiction of the courts in Pune, Maharashtra, India.
      </p>

      <h2>14. Severability</h2>
      <p>
        If any provision of these Terms is found to be invalid, illegal, or unenforceable, the remaining provisions shall continue in full force and effect.
      </p>

      <h2>15. Entire Agreement</h2>
      <p>
        These Terms, along with our Privacy Policy, constitute the entire agreement between you and Sai Ananta regarding your use of the website and supersede any prior agreements or understandings.
      </p>

      <h2>16. Contact Information</h2>
      <p>If you have any questions, concerns, or feedback regarding these Terms, please contact us:</p>
      <p>
        <strong>Sai Ananta</strong><br />
        Laxmi-Narayan Nagar, Wadmukhwadi, Charholi Budruk, Pimpri-Chinchwad, Maharashtra 412105, Maharashtra, India<br />
        <strong>Phone:</strong> +91 70663 31177<br />
        <strong>Email:</strong> info@saiananta.com<br />
        <strong>Website:</strong> https://sai-ananta-website.vercel.app/
      </p>

      <h2>17. Acknowledgment</h2>
      <p>
        By using our website, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.
      </p>

      <hr style={{ margin: '40px 0', border: 'none', borderTop: '1px solid #ccc' }} />
      <p style={{ fontSize: '14px', color: '#666' }}>
        These Terms and Conditions are governed by the laws of India and comply with the Real Estate (Regulation and Development) Act, 2016 (RERA) and the Information Technology Act, 2000.
      </p>
    </div>
  );
};

export default TermsAndConditions;
